import './Banner.scss';

import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';

import { useIsBelowMediumOnly } from '../../hooks/mediaQueries';
import useCardView from '../../hooks/useCardView';
import { useTheme } from '../../hooks/useTheme';
import TRANSLATIONS from '../../translations/translations@default.json';
import FINANCE_BANNER_CONTENT from './FinanceBanner.json';

const DesktopFinanceBanner = ({ index }) => {
	const { isDealsPage } = useSelector((state) => state);

	const { isGridView } = useCardView();

	const theme = useTheme('financeBanner');

	const { title, repExample, terms } = FINANCE_BANNER_CONTENT;

	const isBelowMediumOnly = useIsBelowMediumOnly();

	const gridSize = isGridView && (isDealsPage || isBelowMediumOnly) ? 4 : 3;

	if (gridSize !== index) {
		return null;
	}

	return (
		<li
			className={classnames(
				'flex w-full p-2 my-2 border border-solid border-gray-30 rounded-lg',
				theme.background
			)}>
			<div className="flex flex-col justify-center text-center p-2 w-5/6 lg:w-full">
				<div className={classnames('text-body-xs font-bold', theme.aoFinance)}>
					{TRANSLATIONS.productList.productCard.financeRestyle.aoFinance}
				</div>
				<div className={classnames('text-display-sm px-2', theme.title)}>
					{title}
				</div>
			</div>
			<div className="items-center justify-center p-2 w-full">
				<div
					className={classnames(
						'text-caption text-center',
						theme.repExample.title
					)}>
					{repExample.title}
				</div>
				<div className="flex justify-around w-full mb-3 mt-2">
					{repExample.examples.map((example) => (
						<div className="flex-col text-center px-1" key={example.title}>
							<div
								className={classnames(
									'text-title-sm leading-tight',
									theme.repExample.examples.title
								)}>
								{example.title}
							</div>
							<div
								className={classnames(
									'font-body leading-tight',
									theme.repExample.examples.description
								)}
								style={{ fontSize: '11px' }}>
								{example.description}
							</div>
						</div>
					))}
				</div>
				<div
					className={classnames(
						'font-body text-center leading-none',
						theme.terms
					)}
					style={{ fontSize: '11px' }}>
					{terms.regular}
					<span className="font-bold">{terms.bold}</span>
				</div>
			</div>
		</li>
	);
};

export default DesktopFinanceBanner;
